import { useEffect, useState } from 'react'
import { Link  } from 'react-router-dom';
import TextField from '../components/Form/TextField';
import MetaData from '../layouts/MetaData';
import { useDispatch, useSelector } from 'react-redux';
import { useAlert } from 'react-alert';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Spinner, Image } from 'react-bootstrap';
import TDW_logo from '../assets/Images/vitals_portal_logo.png';
import { PoweredBy } from '../components/common/Branding';
import loginIllustration from '../assets/Images/loginRPM.svg';
import { login, logout } from '../actions/authActions';
import {HIDE_ALERT_MESSAGE} from '../constants/Common';

// The backend resolves the account from email + password and returns its role.
const HOME_BY_ROLE = {
	admin: '/adminDashboard',
	adminStaff: '/adminDashboard',
	HrMedical: '/Nurse/Dashboard',
	HrLead: '/Nurse/Dashboard',
	enrollment: '/enrollment/patients',
	doctor: '/doctor/dashboard',
	billing: '/billing/codes',
	accounting: '/accounting/monthly',
};




const Login = ({ history }) => {

	const alert = useAlert();
	const dispatch = useDispatch();

	const {error : loginError } = useSelector(state => state.common);
	const [show, setShow] = useState(false);
    
	const validate = Yup.object().shape({
		email: Yup.string().email('Invalid email').required('Email is Required'),
		password: Yup.string() 
		  .min(6, 'Too Short!')
		  .max(20, 'Too Long!')
		  .required('Password is Required'),
	  });

	const { isAuthenticated, error, loading, user } = useSelector(state => state.auth);

	useEffect(() => {
		
		if(isAuthenticated === true && user?.role) {
			const home = HOME_BY_ROLE[user.role];
			if (home) {
				history.push(home);
			} else {
				alert.error('Your account has no portal access. Contact your administrator.');
				dispatch(logout());
			}
		}

		if(error){
			alert.error(error);
			dispatch({
                type: HIDE_ALERT_MESSAGE
            })
		}

		if(loginError) {
			alert.error(loginError);
			dispatch({
                type: HIDE_ALERT_MESSAGE
            })
		}

	}, [dispatch, alert, isAuthenticated, user, error, loginError, history])
	
	
	const submitHandler = (values) => {
		dispatch(login(values));
	}
	
    return (
    	<>
		<MetaData title="Login" />
		 <>
				<div className="login-section">
					<img src={loginIllustration} className="login-illustration" alt="Remote patient monitoring illustration" />
					<div className="container">
						<div className="content">
							<Image src={TDW_logo} style={{height:"80px"}} alt="Vitals Portal"/>
							<PoweredBy className="w-100 mt-1" />		
								
							<div className="col-md-12" >
								<br />
								<div>
									<h3 style={{color: '#004aad'}}>Welcome!</h3>
									<h5 style={{color: '#999'}}>Sign in to your Account</h5>
								</div>
								<Formik initialValues={{
									email: '',
									password: ''
								}}
								validationSchema={validate}
								onSubmit={values => {
									submitHandler(values)
								}}
								>
										<div>
											<Form>
												<TextField 
													label="Email Address" 
													name="email" 
													type="email" 
													placeholder="Enter Email"
												/>

												<TextField 
													label="Password" 
													name="password" 
													type={show === false ? "password" : "text"}	
													placeholder="Enter Password"
												/>

													<div style={{float: 'right'}}>
														<input type="checkbox" 
														 name="show" 
														 id="show"
														 value={show}
														 onChange={() => setShow(!show)}
														/>
														&nbsp;&nbsp;<label htmlFor="show" className='text-muted' style={{fontSize: '14px'}}>
															Show Password
														</label>
													</div>

												<Link to="/auth/forgot">
													<span className="forgot-password-link">Forgot Password ?</span>
												</Link>
												
												<br/>
												
													{/* <button className="reset-btn" type="reset"><i className='bx bx-reset' ></i></button> */}
													<button className="edit-pill" type="submit" style={{width: '100%'}}>
														{loading ? <Spinner animation="border" style={{height: '20px', width: '20px'}}/> : 
														'Login'}
													</button>
											</Form>
										</div>
								</Formik>											
							</div>
						</div>
					</div>
				</div>
		</>
        
    </>
    )
}

export default Login
